<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    class="sidenav"
    [style.width]="store.sidenavWidth()"
  >
    <div class="section-header">{{
      store.isSidenavCollapsed() ? '' : ('overviewSideNav' | translate | async)
    }}</div>
    <mat-nav-list>
      @if(store.menuItems().length > 3){
      <a
        mat-list-item
        [routerLink]="store.menuItems()[3].route"
        routerLinkActive="selected-menu-item"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        class="sidenav-menu-item menu-item"
      >
        <mat-icon
          mat-list-icon
          matListItemIcon
          [class.collapsed-icon]="store.isSidenavCollapsed()"
          >{{ store.menuItems()[3].icon }}</mat-icon
        >
        @if (!store.isSidenavCollapsed()) {
        <span mat-line>{{
          store.menuItems()[3].name | translate | async
        }}</span>
        } </a
      >}
    </mat-nav-list>
    <mat-divider></mat-divider>
    <div class="section-header">{{
      store.isSidenavCollapsed()
        ? ''
        : ('configurationSideNav' | translate | async)
    }}</div>
    <mat-nav-list>
      @for (item of store.menuItems(); track item.name) { @if (item.name !==
      store.menuItems()[3].name) {
      <a
        mat-list-item
        [routerLink]="item.route"
        routerLinkActive="selected-menu-item"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        class="sidenav-menu-item menu-item"
      >
        <mat-icon
          mat-list-icon
          matListItemIcon
          [class.collapsed-icon]="store.isSidenavCollapsed()"
          >{{ item.icon }}</mat-icon
        >
        @if (!store.isSidenavCollapsed()) {
        <span mat-line>{{ item.name | translate | async }}</span>

        }
      </a>
      } }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content
    class="content"
    [style.margin-left]="(isHandset$ | async) ? '0' : store.sidenavWidth()"
  >
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
